export const GAME_STATES = {
	IDLE: 'idle',
	LOBBY: 'lobby',
	COUNTDOWN_START: 'countdown_start', // Countdown before game starts
	PLAYING: 'playing',
	ROUND_END: 'round_end',
	COUNTDOWN_NEXT: 'countdown_next', // Countdown between questions
	RESULTS_COUNTDOWN: 'results_countdown', // Countdown before final results
	ENDED: 'ended',
};

export const SOCKET_EVENTS = {
	// Client -> Server
	CREATE_GAME: 'create_game',
	JOIN_GAME: 'join_game',
	EXIT_GAME: 'exit_game',
	START_GAME: 'start_game',
	SUBMIT_ANSWER: 'submit_answer',
	NEXT_QUESTION: 'next_question', // Host action
	VIEW_RESULTS: 'view_results', // Host action
	REGISTER_SESSION: 'register_session',

	// Server _> Client
	CONNECT: 'connected',
	DISCONNECT: 'disconnect',
	RECONNECT_ATTEMPT: 'reconnect_attempt',
	ERROR: 'error', // General error message
	SESSION_ESTABLISHED: 'session_established',

	// Game specific Server -> Client
	GAME_CREATED: 'game_created', // To creator
	JOINED_GAME: 'joined_game', // To joiner
	PLAYER_UPDATE: 'player_update', // Broadcast on join/leave/score change
	HOST_CHANGED: 'host_changed', // Broadcast when host changes
	GAME_START_INITIATED: 'game_start_initiated', // Broadcast game start countdown
	QUESTION_COUNTDOWN: 'question_countdown', // Broadcast next question countdown
	RESULTS_COUNTDOWN: 'results_countdown', // Broadcast results countdown
	NEW_QUESTION: 'new_question', // Broadcast new question data
	ANSWER_RESULT: 'answer_result', // To submitter about their answer
	ROUND_RESULTS: 'round_results', // Broadcast results after round ends
	GAME_RESULTS: 'game_results', // Broadcast final game results
	GAME_ENDED: 'game_ended', // Broadcast when game ends prematurely (e.g., host disconnect)
	QUESTIONS_LOADED: 'questions_loaded', // To host when questions are ready
	GAME_STATE_SYNC: 'game_state_sync',
	GAME_RESET: 'game_reset',
};
